<div class="page-content-area" style="overflow-y: auto;">
  <div class="page-content-area__header">
    <div class="page-title-area">
      <div class="page-title-area__left-block">
        <h1 class="page-title">
          Danh mục đơn vị
        </h1>
      </div>
    </div>
  </div>
  <div style="margin: 5px;">
    <p-toast />
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>
      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="col-12 md:col-6 p-fluid p-formgrid grid">
          <div class="col-12 md:col-6">
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-search"></i>
              </p-inputGroupAddon>
              <input pInputText placeholder="Tìm kiếm" [(ngModel)]="code" formControlName="code" (keyup.enter)="onSearch()" />
            </p-inputGroup>
          </div>
          <div class="col-12 md:col-3">
            <p-button [outlined]="true" (click)="onSearch()" [style]="{'max-width':'150%', 'text-align':'center'}"
              icon="pi pi-search" label="Tìm kiếm"></p-button>
          </div>
        </div>
        <div class="col-12 md:col-6 p-fluid p-formgrid grid" style="justify-content: flex-end !important;">
        </div>
      </div>
    </form>
  </div>
  <div class="body" style="margin: 5px;">
    <div class="data-view-main-action-area__right-block">
      <div class="h-mb-8">
        {{(pageIndex -1) * pageSize + 1}} - {{pageIndex * pageSize}} {{'LIST.OFF' | translate}}
        {{totalRecord}}
      </div>
      <button pButton pRipple type="button" icon="pi pi-angle-left" (click)="onPrePage()" [disabled]="pageIndex == 1"
        class="p-button-rounded p-button-text mr-2 mb-2"></button>
      <button pButton pRipple type="button" icon="pi pi-angle-right" (click)="onNextPage()"
        [disabled]="pageIndex > totalRecord / pageSize" class="p-button-rounded p-button-text mr-2 mb-2"></button>
      <button pButton pRipple type="button" icon="ci ci-data-1" (click)="visibleCols.toggle($event)"
        class="p-button-rounded p-button-text mr-2 mb-2"></button>
      <p-overlayPanel #visibleCols [hideTransitionOptions]="'0ms'" [showTransitionOptions]="'0ms'" appendTo="body"
        styleClass="ag-overlay-menu style-2">
        <div class="ag-overlay-menu__title">
          <span (click)="resetColsVisibility()" class="ag-overlay-menu__clear-btn">
            {{getVisibleColsNumber()}}
            <span class="ag-overlay-menu__clear-icon ci ci-close"></span>
          </span>

          <span class="__text">
            {{'LIST.COLS_SELECTED' | translate}}
          </span>
        </div>

        <div *ngFor="let col of cols" [class.-activated]="col.visible" class="ag-overlay-menu__item-wrapper">
          <div class="ag-overlay-menu__item">
            <p-checkbox [(ngModel)]="col.visible" [label]="col.header" binary="true" (click)="onSelectedVisible()">
            </p-checkbox>
          </div>
        </div>
      </p-overlayPanel>
    </div>
    <div class="table-wrapper setpading">
      <!--  class="ag-table -status-style-border-left" -->
      <p-table [columns]="cols" [value]="dataSource" [rows]="pageSize" [totalRecords]="totalRecord" [customSort]="true"
        [scrollHeight]="'80vh'" [scrollable]="true" (onSort)="onSort($event)" (onPage)="onPage($event)"
        [tableStyle]="{ 'min-width': setWidth, 'width': 'auto !important' }" [loading]="isLoading" [lazy]="true"
        styleClass="p-datatable-gridlines">

        <ng-template pTemplate="colgroup">
          <colgroup>
            <ng-container *ngFor="let col of cols">
              <col [style.width]="col.width ? col.width : 'auto'" [hidden]="!col.visible" />
            </ng-container>
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>
              <p-checkbox (onChange)="onChangeBulkSelection()" [(ngModel)]="isCheckAll" [binary]="true">
              </p-checkbox>
            </th>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.sort" [hidden]="!col.visible" [pSortableColumn]="col.field">
                <div class="h-flex-el -h-space-between">
                  <div class="h-overflow-break-word">{{ col.header }}</div>
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </div>
              </th>

              <th *ngIf="!col.sort" [hidden]="!col.visible">
                <div class="h-overflow-break-word">{{ col.header }}</div>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr [class.ag-tr-status]="rowData.status" [class.ag-tr-status-danger]="rowData.status === 3"
            [class.ag-tr-status-warning]="rowData.status === 2" [class.ag-tr-status-success]="rowData.status === 1">
            <td>
              <p-checkbox name="group" [value]="rowData" (onChange)="checkSelectionState()"
                [(ngModel)]="selectedItems"></p-checkbox>
            </td>
            <td *ngFor="let col of columns" [hidden]="!col.visible" [ngSwitch]="col.field">
              <span *ngSwitchCase="'stt'">{{ rowIndex + 1 }}</span>
              <span *ngSwitchCase="'status'">{{ rowData.status == 1 ? 'Đang áp dụng' : 'Ngừng áp dụng' }}</span>
              <span *ngSwitchDefault>{{ rowData[col.field] }}</span>
            </td>
          </tr>
        </ng-template>  
      </p-table>
    </div>
  </div>
</div>